import React, { useState, useEffect } from 'react';

function Header({ scrollToSection }) {
    const [scrolled, setScrolled] = useState(false);
    const [showOffcanvas, setShowOffcanvas] = useState(false);

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Закрывать меню при изменении размера экрана
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 992) {
                setShowOffcanvas(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const navItems = [
        { href: '#about', label: 'О нас', icon: 'ℹ️' },
        { href: '#services', label: 'Услуги', icon: '🔧' },
        { href: '#portfolio', label: 'Портфолио', icon: '🖼️' },
        // { href: '#pricing', label: 'Цены', icon: '💰' },
        { href: '#contact', label: 'Контакты', icon: '📞' }
    ];

    const handleNavClick = (sectionId) => {
        scrollToSection(sectionId);
        setShowOffcanvas(false);
    };

    return (
        <>
            <nav className={`navbar navbar-expand-lg fixed-top ${scrolled ? 'navbar-scrolled' : ''}`}>
                <div className="container">
                    <a className="navbar-brand" href="#home">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" width="40" height="40">
                            <rect x="15" y="15" width="170" height="170" rx="32" ry="32"
                                  fill="#1a1a2e" stroke="#e94560" stroke-width="4"/>

                            <text x="82" y="132" font-family="Arial, Helvetica, sans-serif"
                                  font-size="108" font-weight="bold" text-anchor="middle"
                                  fill="#ffffff">
                                К
                            </text>

                            <text x="132" y="82" font-family="Arial, Helvetica, sans-serif"
                                  font-size="50" font-weight="bold" text-anchor="middle"
                                  fill="#f39c12">
                                2
                            </text>
                        </svg>
                    </a>

                    {/* Десктопное меню */}
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav ms-auto">
                            {navItems.map((item, index) => (
                                <li key={index} className="nav-item">
                                    <a
                                        className="nav-link"
                                        href={item.href}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            scrollToSection(item.href.replace('#', ''));
                                        }}
                                    >
                                        {item.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Кнопка Offcanvas для мобильных */}
                    <button
                        className="btn btn-outline-light d-lg-none"
                        onClick={() => setShowOffcanvas(true)}
                        aria-label="Открыть меню"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                </div>
            </nav>

            {/* Затемнение фона */}
            {showOffcanvas && (
                <div
                    className="offcanvas-backdrop fade show"
                    onClick={() => setShowOffcanvas(false)}
                ></div>
            )}

            {/* Offcanvas меню */}
            <div
                className={`offcanvas offcanvas-end ${showOffcanvas ? 'show' : ''}`}
                tabIndex="-1"
                id="offcanvasNavbar"
                aria-labelledby="offcanvasNavbarLabel"
            >
                <div className="offcanvas-header border-bottom">
                    <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
                        K<span className="text-warning">2</span>
                    </h5>
                    <button
                        type="button"
                        className="btn-close btn-close-white"
                        onClick={() => setShowOffcanvas(false)}
                        aria-label="Закрыть меню"
                    ></button>
                </div>
                <div className="offcanvas-body">
                    <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
                        {navItems.map((item, index) => (
                            <li key={index} className="nav-item mb-2">
                                <a
                                    className="nav-link fs-5 py-2 px-3 rounded"
                                    href={item.href}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleNavClick(item.href.replace('#', ''));
                                    }}
                                    style={{
                                        color: '#ffffff',
                                        transition: 'all 0.3s ease',
                                        backgroundColor: 'transparent'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                    }}
                                >
                                    <span className="me-2">{item.icon}</span>
                                    {item.label}
                                </a>
                            </li>
                        ))}
                    </ul>

                    <div className="mt-4 p-3 rounded" style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)' }}>
                        <h6 className="text-light mb-3">Свяжитесь с нами</h6>
                        <div className="mb-2 text-light">
                            <span className="me-2">📞</span>
                            <div className="d-flex align-items-center flex-column">
                                <a href="tel:+79068500007" className="text-light text-decoration-none mb-2">
                                    +7 (906) 850-00-07
                                </a>
                                <a href="tel:+79090948654" className="text-light text-decoration-none">
                                    +7 (909) 094-86-54
                                </a>
                            </div>
                        </div>
                        <p className="mb-2 text-light">
                            <span className="me-2">✉️</span>
                            <a href="mailto:info@ceilpro.ru" className="text-light text-decoration-none">
                                info@ceilpro.ru
                            </a>
                        </p>
                        <p className="mb-0 text-light">
                            <span className="me-2">📍</span>
                            г. Магнитогорск
                        </p>
                    </div>

                    <div className="mt-4">
                        <button
                            className="btn btn-warning w-100"
                            onClick={() => handleNavClick('contact')}
                        >
                            Бесплатная консультация
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Header;